import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import MomentUtils from "@date-io/moment";
import { Grid, Paper, Box, Table, TableContainer, TableHead, TableBody, TableCell, TableRow, CircularProgress, Button, TextField } from '@material-ui/core';
import { FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import AlertBox from './AlertBox';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import grey from "@material-ui/core/colors/grey";

import { stationListRequest } from '../actions/stationQueryAction';
import { fixrecordListRequest, fixrecordAddRequest, fixrecordDeleteRequest } from '../actions/fixRecordAction';
import { ContactSupportOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    select: {
        paddingTop: theme.spacing(3),
        backgroundColor: 'white'
    },
    selectMenu: {
        fontSize: '1rem',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#AED6F1',
        //        color: theme.palette.common.white,
        fontSize: 20,
        border: '1px solid #ABB2B9'
    },
    body: {
        fontSize: 16,
//        verticalAlign: 'baseline',
        border: '1px solid #ABB2B9',
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const FixRecord = () => {
    const style = useStyles();
    const dispatch = useDispatch();
    const stationList = useSelector(state => state.stationList);
    const fixrecordList = useSelector(state => state.fixrecord);
    const [alert, setAlert] = useState({});
    const [pageInfo, setPageInfo] = useState({ page: 1, pageSize: 10, pageCount: 0 });
    const [pageCount, setPageCount] = useState(0);
    const [stations, setStations] = useState([]);
    const [selectStation, setSelectStation] = useState('');
    const [openNew, setOpenNew] = useState(false);
    const [newData, setNewData] = useState({ issue_datetime: moment().format('YYYY-MM-DD'), station_id: '', explan: '' });

    useEffect(() => {
        if (stationList && stationList.stations && stationList.stations.length > 0) {

            setStations(stationList.stations);
            setSelectStation(stationList.stations[0].ID);
        } else {
            if (!stationList || stationList.status === 0) {
                dispatch(stationListRequest());
            }
        };
    }, [stationList, dispatch]);


    useEffect(() => {
        if (selectStation)
            setPageInfo({ ...pageInfo, page: 1 });
            dispatch(fixrecordListRequest(selectStation, 1, pageInfo.pageSize));
    }, [selectStation]);


    useEffect(() => {
        if (fixrecordList.status === 2) {
            let count = Math.ceil(fixrecordList.total / pageInfo.pageSize);
            setPageInfo({ page: fixrecordList.page, pageSize: fixrecordList.per_page, pageCount: count });

        } else if (fixrecordList.status === 3) {
            setAlert({ open: true, type: 'error', text: fixrecordList.error });
        }

        if (openNew) {
            setOpenNew(false);
        }
    }, [fixrecordList])

    const onPageChanged = (event, page) => {
        setPageInfo({ ...pageInfo, page: page });
        dispatch(fixrecordListRequest(selectStation, page, pageInfo.pageSize));
    }

    const onAddClicked = (event) => {
        setOpenNew(true);
        setNewData({ issue_datetime: '', station_id: '', explan: '' });
    }

    const onAddSaveClicked = (event) => {
        event.preventDefault();

        console.log(selectStation);

        if (!selectStation) {
            setAlert({ open: true, type: 'error', text: '請選擇案場 !' });
            return;
        }

        if (!newData.explan) {
            setAlert({ open: true, type: 'error', text: '欄位需要填入資料 !' });
            return;
        }

        let date = moment(newData.issue_datetime, 'YYYY-MM-DD', true);

        if (!date.isValid()) {
            setAlert({ open: true, type: 'error', text: '日期 非正確格式 !' });
            return;
        }

        let data = {
            ...newData,
            station_id: Number(selectStation),
        }

        dispatch(fixrecordAddRequest(data));
        setNewData({ issue_datetime: moment().format('YYYY-MM-DD'), station_id: '', explan: '' });
    }

    const onDeleteClicked = (event, id) => {
        event.preventDefault();
        dispatch(fixrecordDeleteRequest(selectStation, id, pageInfo.page, pageInfo.pageSize));
    }

    return (
        <Box m={5}>
            <AlertBox open={alert.open} type={alert.type} text={alert.text} close={() => setAlert({ ...alert, open: false })}></AlertBox>
            <Box width="95%" style={{ margin: '0 auto', minWidth: 900 }}>
                <Box my={2}>
                    <FormControl className={style.select} style={{ minWidth: 300 }}>
                        <InputLabel style={{ fontSize: 20, padding: 5 }}>選取案場</InputLabel>
                        <Select classes={{ selectMenu: style.selectMenu }} variant="filled"
                            value={selectStation}
                            onChange={(e) => setSelectStation(e.target.value)}
                        >
                            {stations && stations.length > 0 && stations.map((x, i) => (
                                <MenuItem key={i} value={x.ID}>{`${x.ID} - ${x.Name}`}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell width="120">處理日期</StyledTableCell>
                                <StyledTableCell>內容說明</StyledTableCell>
                                <StyledTableCell width="150">建立時間</StyledTableCell>
                                <StyledTableCell width="50"></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        <StyledTableRow style={{backgroundColor: 'white'}}>
                            <StyledTableCell style={{verticalAlign:'top'}}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker inputVariant="outlined" value={newData.issue_datetime} format="YYYY-MM-DD" autoOk="true"
                                        onChange={(date) => { setNewData({ ...newData, issue_datetime: moment(date).format('YYYY-MM-DD') }) }} />
                                </MuiPickersUtilsProvider>
                            </StyledTableCell>
                            <StyledTableCell colSpan={3} style={{ whiteSpace: "pre-wrap" }}>
                                <Box>
                                    <TextField variant="outlined"  multiline={true} fullWidth={true} 
                                        value={newData.explan} onChange={(e) => { setNewData({ ...newData, explan: e.target.value }) }} />
                                </Box>
                                <Box mt={2}>
                                <Button variant="contained" color="primary" onClick={(e) => onAddSaveClicked(e)}>新 增</Button>
                                </Box>
                            </StyledTableCell>
                        </StyledTableRow>
                        {fixrecordList.status === 1 ?
                            <StyledTableRow>
                                <StyledTableCell align="center" colSpan={4}><CircularProgress color="secondary" thickness={6} /></StyledTableCell>
                            </StyledTableRow>
                        :
                                 fixrecordList.data ?
                                    fixrecordList.data.map((x, i) => (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell>{x.IssueDatetime}</StyledTableCell>
                                            <StyledTableCell style={{ whiteSpace: "pre-wrap" }}>{x.Explan}</StyledTableCell>
                                            <StyledTableCell>{x.UpdateDatetime && moment(x.UpdateDatetime).format('YYYY-MM-DD hh:mm:ss')}</StyledTableCell>
                                            <StyledTableCell>
                                                <Button variant="contained" size="small" color="primary" onClick={(e) => onDeleteClicked(e, x.ID)}>刪除</Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                    :
                                    <StyledTableRow>
                                        <StyledTableCell align="center" colSpan={5}>沒有資料</StyledTableCell>
                                    </StyledTableRow>
                                }
                                <StyledTableRow>
                                    <StyledTableCell colSpan={4}>
                                        <Pagination count={pageInfo.pageCount} defaultPage={pageInfo.page} variant="outlined" shape="rounded"
                                            onChange={(e, p) => { onPageChanged(e, p) }} />
                                    </StyledTableCell>
                                </StyledTableRow>
                        
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default FixRecord;